"use client";

import Script from "next/script";

interface AdsterraBannerProps {
  className?: string;
  position?: "top" | "middle" | "bottom";
}

export default function AdsterraBanner({
  className = "",
  position = "bottom",
}: AdsterraBannerProps) {
  const positionClasses = {
    top: "mt-0 mb-8",
    middle: "my-8",
    bottom: "mt-8 mb-0",
  };

  return (
    <div
      className={`w-full flex justify-center ${positionClasses[position]} ${className}`}
    >
      <div className="w-full max-w-full overflow-hidden">
        <Script
          async
          data-cfasync="false"
          src="//pl28173225.effectivegatecpm.com/b9849a6596031ea2a41b84cbdb07f560/invoke.js"
          strategy="lazyOnload"
        />
        <div
          id="container-b9849a6596031ea2a41b84cbdb07f560"
          className="min-h-[90px] flex items-center justify-center"
        />
      </div>
    </div>
  );
}
